import { useState, useEffect } from "react";
import { DrawerComponent, Modal } from "src/components/DialogComponent";
import Button from "src/components/Button";
import TGButton from "src/components/ui/TGButton";
import { useAppDispatch, useAppSelector } from "src/hooks/redux";
import _ from "lodash";
import { addItemRequest, deleteItemRequest, updateItemRequest } from "src/modules/spItems/api";
import { selectCurrentUser, selectUsers } from "src/modules/users/selector";
import Form from "src/components/Form";
import { selectAddStatus, selectItem, selectItems } from "src/modules/spItems/selectors";
import Loading from "src/components/Loading";
import {
  myTasks5WayDependListName,
  myTasksDepartmentsListName,
  myTasksDeviationReportDependListName, myTasksDeviationReportKpiByTriggerListName,
  myTasksKpiByTriggerListName,
  myTasksLocationsListName
} from "src/api/config/myTasksLists.config";
import { getItem, getItems } from "src/modules/spItems/actions";
import moment from "moment";
import { useSearchParams } from "react-router-dom";
import { myTasks5WayEditorListName, myTasks5WayListName } from "src/api/config/myTasks5Way.config";
import { emailsSender, siteUrl } from "src/api/config";
import { emailAPI } from "src/utils/api.utils";
import { fiveWhyStatus, FiveWhyType } from "src/api/config/systemSwitch";
import { mode, autoCloseModal } from "src/constants";
const { sendEmail } = emailAPI();

const taskCardButtonClassName =
  "block w-full bg-transparent px-[28px] py-[16px] text-center font-normal leading-none tracking-normal text-darkblue hover:bg-[#F4F6FC]";

const Add5Way = ({ zIndex, type, fromTaskCard = false }: { zIndex: number, type: string, fromTaskCard?: boolean }) => {
    const dispatch = useAppDispatch();
    const currentUser: any = useAppSelector((state) => selectCurrentUser(state));
    const [open, setOpen] = useState(false);
    const [cancel, setCancel] = useState(false);
    const [add5Way, setAdd5Way] = useState(false);
    const [closeAllModals, setCloseAllModals] = useState(false);
    const [fields, setFields] = useState<any>([
        {
            type: 'date',
            require: true,
            key: 'Date5Way',
            minDate: moment(new Date()).subtract(7, 'days').toDate(),
            maxDate: moment(new Date()).toDate(),
            title: 'Дата',
            placeholder: 'дд.мм.гггг',
            width: 'w-full sm:w-[calc(50%-10px)]'
        },
        {
            type: 'select',
            require: true,
            key: 'Location',
            title: 'Локация',
            placeholder: 'Не выбрано',
            width: 'w-full sm:w-[calc(50%-10px)]'
        },
        {
            type: 'select',
            require: true,
            key: 'Department',
            title: 'Отдел',
            placeholder: 'Не выбрано',
            width: 'w-full sm:w-[calc(50%-10px)]'
        },
        {
            type: 'select',
            require: true,
            key: 'Region',
            title: 'Участок',
            placeholder: 'Не выбрано',
            width: 'w-full sm:w-[calc(50%-10px)]'
        },
        {
            type: 'select',
            require: true,
            key: 'Trigger',
            title: type === FiveWhyType && 'Триггер 5Почему' || 'Триггер отчета об отклонении',
            placeholder: 'Не выбрано',
            width: 'w-full sm:w-[calc(50%-10px)]'
        },
        {
            type: 'select',
            require: false,
            key: 'ProblemRepeat',
            title: 'Повторяющаяся проблема?',
            placeholder: 'Не выбрано',
            width: type === FiveWhyType ? 'w-full sm:w-[calc(50%-10px)]' : 'w-full sm:w-[calc(50%-10px)]'
        },
        {
            type: 'number',
            require: false,
            key: 'ProblemsCount',
            min: 1,
            hide: true,
            title: 'Кол-во повторений',
            width: 'w-full sm:w-[calc(50%-10px)]'
        },
        {
            type: 'select',
            require: false,
            key: 'KPI',
            hide: true,
            title: 'KPI',
            placeholder: 'Не выбрано',
            width: 'w-full sm:w-[calc(50%-10px)]'
        },
        {
            type: 'editors',
            key: 'Editors',
            title: "Участники",
            width: 'w-full',
            type5Way: type
        },
        {
            type: 'textArea',
            key: 'Description',
            require: true,
            title: 'Краткое описание проблемы (Что и где произошло)',
            placeholder: 'Введите краткое описание проблемы',
            width: 'w-full'
        },
        {
            type: 'textArea',
            key: 'Details',
            require: true,
            noticeIcon: true,
            notice: `<span class="w-full"><strong>Что?</strong> (Что случилось, в чем именно проблема?)<br/>
<strong>Где?</strong> (Где именно проблема в продукте/процессе и где была обнаружена?) <br/>
<strong>Когда?</strong> (Когда проблема началась, когда была обнаружена?) <br/>
<strong>Как?</strong> (Есть ли стандарт и соблюдался ли он на момент возникновения проблемы?) <br/>
<strong>Кто?</strong> (Кто обнаружил проблему?) <br/>
<strong>Насколько велика проблема?</strong> (Количество затронутого продукта / минуты простоя, риски от проблемы)<span>`,
            title: 'Шаг 1. Детальное описание проблемы',
            placeholder: "Детально опишите проблему",
            width: 'w-full'
        },
        {
            type: 'textArea',
            key: 'Actions',
            require: true,
            title: 'Шаг 2. Немедленные действия',
            placeholder: "Укажите немедленные корректирующие действия и эффект от них",
            width: 'w-full'
        }
    ]);
    const [dependenceFields, setDependenceFields] = useState<any>({
        Location: null,
        Department: null,
        Region: null,
        Trigger: null,
    });
    const [dependenceFields5Way, setDependenceFields5Way] = useState<any>({
        Trigger: null
    });
    const [formData, setFormData] = useState<any>(null);
    const [defaultValues, setDefaultValues] = useState<any>({
        Date5Way: {
            startDate: new Date(),
            endDate: new Date()
        },
        Editors: "",
        Status: fiveWhyStatus.process,
        ProblemsCount: 1
    });
    const users: any = useAppSelector(selectUsers);
    const statusAdd5Way = useAppSelector((state) => selectAddStatus(state, myTasks5WayListName));
    const [customLoading, setCustomLoading] = useState(false);
    const locations: any = useAppSelector(state => selectItems(state, myTasksLocationsListName));
    const dependencies: any = useAppSelector(state => selectItems(state, myTasks5WayDependListName));
    const dependenceTrigger: any = useAppSelector(state => selectItem(state, myTasksKpiByTriggerListName));
    const dependenceDeviationReportTrigger: any = useAppSelector(state => selectItem(state, myTasksDeviationReportKpiByTriggerListName));
    const dependenciesDeviationReport: any = useAppSelector(state => selectItems(state, myTasksDeviationReportDependListName));
    const departments: any = useAppSelector((state) => selectItems(state, myTasksDepartmentsListName));

    const [ID5WayAdd, setID5WayAdd] = useState<any>(null);
    const [query, setQuery] = useSearchParams();
    const [kpi, setKPI] = useState<any>(null);
    const [inc, setInc] = useState<any>(null);
    const [default5WayCardDataInc, setDefault5WayCardDataInc] = useState<any>(null);
    const [create5WayID, setCreate5WayID] = useState<any>(0);
    const [remove5Way, setRemove5Way] = useState(false);
    const [card5WayTree, setCard5WayTree] = useState<any>([]);
    const [openTree, setOpenTree] = useState(false);
    const [problemInTree, setProblemInTree] = useState("");
    const [problemRepeatCounShow, setProblevRepeatCounShow] = useState<any>(null);

    useEffect(() => {
        if (locations.length > 0 && !defaultValues.Location && departments.length > 0) {
            let defaultLocation: any = null;
            const defaultDepartments = departments.filter(department => currentUser.department && department.User_Department && department.User_Department.indexOf(currentUser.department) !== -1).map(department => {
              return { id: department.ID, name: department.Title, disabled: false }
            });


            // 1. Глобальный админ - берем первую локацию
            if (currentUser?.isAdmin) {
                defaultLocation = locations[0];
            }
            // 2. Админ фабрики
            else if (currentUser?.isFactoryAdmin) {
                defaultLocation = locations[0];
            }
            // 3. Админ локации
            else if (currentUser?.isLocationAdminMyTasks?.length > 0) {
                const locationId = currentUser.isLocationAdminMyTasks[0];
                defaultLocation = locations.find((loc: any) => loc.ID === locationId);
            }
            // 4. Редактор локации
            else if (currentUser?.isLocationEditorMyTasks?.length > 0) {
                const locationId = currentUser.isLocationEditorMyTasks[0];
                defaultLocation = locations.find((loc: any) => loc.ID === locationId);
            }

            if (defaultLocation) {
                setDefaultValues((prev: any) => ({
                    ...prev,
                    Location: { id: defaultLocation.ID, name: defaultLocation.Title }
                }));
                setDependenceFields((prev: any) => ({
                    ...prev,
                    Location: { id: defaultLocation.ID, name: defaultLocation.Title }
                }));
            }

            if (defaultDepartments) {
              setDefaultValues((prev: any) => ({
                ...prev,
                Department: defaultDepartments.length > 0 && defaultDepartments[0] || null
              }));
            }
        }
    }, [currentUser, locations, departments]);

    //Расставляем опции селектов локации и статических селектов
    useEffect(() => {
        if (currentUser.id) {
            setDefaultValues((prevState: any) => {
                return { ...prevState, Editors: currentUser.email }
            });
            const tempFieldsForm = [...fields];
            for (let i = 0; i < tempFieldsForm.length; i++) {
                if (tempFieldsForm[i]['key'] === 'Location') {
                    const options = locations.filter((location: any) => {
                        if (
                        currentUser.isAdmin ||
                        (currentUser.isLocationEditorMyTasks &&
                            currentUser.isLocationEditorMyTasks.length > 0 &&
                            currentUser.isLocationEditorMyTasks.find(
                            (locationID: any) => locationID === location.ID
                            )) ||
                        (currentUser.isLocationAdminMyTasks &&
                            currentUser.isLocationAdminMyTasks.length > 0 &&
                            currentUser.isLocationAdminMyTasks.find(
                            (locationID: any) => locationID === location.ID
                            ))
                        ) {
                        return true;
                        } else {
                        return false;
                        }
                    }).map((location: any) => {
                        return {
                        id: location.ID,
                        name: location.Title,
                        available: true,
                        };
                    });
                    tempFieldsForm[i]['options'] = [...options];
                }
                if (tempFieldsForm[i]['key'] === 'KPI') {
                    tempFieldsForm[i]["disabled"] = true;
                }
                if (tempFieldsForm[i]['key'] === 'ProblemRepeat') {
                    tempFieldsForm[i]['options'] = [
                        {
                            id: 1,
                            name: 'Да'
                        },
                        {
                            id: 0,
                            name: 'Нет'
                        }
                    ]
                }
            }
            setFields([...tempFieldsForm]);
        }
    }, [locations, currentUser]);

    useEffect(() => {
        if (localStorage.getItem('NEW_INC') && localStorage.getItem('default5WayCardDataInc')) {
            const default5WayCardDataIncTemp: any = localStorage.getItem('default5WayCardDataInc') || {}
            setInc(Number(localStorage.getItem('NEW_INC')));
            setDefault5WayCardDataInc(JSON.parse(default5WayCardDataInc));
            setDefaultValues((prevState: any) => {
                return { ...prevState, ...JSON.parse(default5WayCardDataIncTemp) }
            });
            localStorage.setItem('NEW_INC', '');
            localStorage.setItem('default5WayCardDataInc', '');
            setOpen(true);
        }
        return () => {
            setInc(null);
            setDefault5WayCardDataInc(null);
        }
    }, []);

    useEffect(() => {
        if (dependenceFields["Location"]) {
            setKPI(null);
            dispatch(getItems({ listName: type === FiveWhyType && myTasks5WayDependListName || myTasksDeviationReportDependListName, filters: { Location: dependenceFields["Location"]["id"] } }));
            const tempFieldsForm = [...fields];
            for (let i = 0; i < tempFieldsForm.length; i++) {
                if (tempFieldsForm[i]["key"] === "Department") {
                    tempFieldsForm[i]["disabled"] = false;
                }
                if (tempFieldsForm[i]["key"] === "Region") {
                    tempFieldsForm[i]["disabled"] = true;
                }
                if (tempFieldsForm[i]["key"] === "Trigger") {
                    tempFieldsForm[i]["disabled"] = true;
                }
            }
            setFields([...tempFieldsForm]);
        }
        if (!dependenceFields["Location"]) {
            const tempFieldsForm = [...fields];
            for (let i = 0; i < tempFieldsForm.length; i++) {
                if (tempFieldsForm[i]["key"] === "Department" || tempFieldsForm[i]["key"] === "Region" || tempFieldsForm[i]["key"] === "Trigger") {
                    tempFieldsForm[i]["disabled"] = true;
                }
            }
            setFields([...tempFieldsForm]);
        }
        if (dependenceFields["Department"]) {
            const tempFieldsForm = [...fields];
            for (let i = 0; i < tempFieldsForm.length; i++) {
                if (tempFieldsForm[i]["key"] === "Region") {
                    tempFieldsForm[i]["disabled"] = false;
                }
            }
            setFields([...tempFieldsForm]);
        }
        if (dependenceFields["Region"]) {
            const tempFieldsForm = [...fields];
            for (let i = 0; i < tempFieldsForm.length; i++) {
                if (tempFieldsForm[i]["key"] === "Trigger") {
                    tempFieldsForm[i]["disabled"] = false;
                }
            }
            setFields([...tempFieldsForm]);
        }
    }, [dependenceFields]);

    useEffect(() => {
        if (dependenceFields5Way["Trigger"]) {
            dispatch(getItem({ listName: type === FiveWhyType && myTasksKpiByTriggerListName || myTasksDeviationReportKpiByTriggerListName, filters: { Trigger: dependenceFields5Way["Trigger"]["id"] } }));
        }
    }, [dependenceFields5Way]);

    //В списке зависимостей колонка называется Departament, а в списках с аудитами и отделами Department (буква a отличие)

    useEffect(() => {
        const tempFieldsForm = [...fields];
        let tempDependencies: any = [];
        if (type === FiveWhyType) {
            tempDependencies = [...dependencies];
        } else {
            tempDependencies = [...dependenciesDeviationReport];
        }
        for (let i = 0; i < tempFieldsForm.length; i++) {
            if (dependenceFields["Location"]) {
                if (tempFieldsForm[i]["key"] === "Department") {
                    const options = tempDependencies
                        .filter((dependence: any) => dependence.Location.ID === dependenceFields["Location"]["id"])
                        .map((dependence: any) => {
                            return {
                                id: dependence.Departament.ID,
                                name: dependence.Departament.Title,
                            };
                        });
                    tempFieldsForm[i]["options"] = _.uniqWith(options, _.isEqual).length > 0 && _.uniqWith(options, _.isEqual) || [{
                        id: 0,
                        name: "Нет вариантов",
                        available: false
                    }];
                }
            }
            if (dependenceFields["Department"]) {
                if (tempFieldsForm[i]["key"] === "Region") {
                    const options = tempDependencies
                        .filter((dependence: any) => dependence.Departament.ID === dependenceFields["Department"]["id"])
                        .map((dependence: any) => {
                            return {
                                id: dependence.Region.ID,
                                name: dependence.Region.Title,
                            };
                        });
                    tempFieldsForm[i]["options"] = _.uniqWith(options, _.isEqual).length > 0 && _.uniqWith(options, _.isEqual) || [{
                        id: 0,
                        name: "Нет вариантов",
                        available: false
                    }];
                }
            }
            if (dependenceFields["Region"]) {
                if (tempFieldsForm[i]["key"] === "Trigger") {
                    const options = tempDependencies
                        .filter((dependence: any) => dependence.Departament.ID === dependenceFields["Department"]["id"] && dependence.Region.ID === dependenceFields["Region"]["id"])
                        .map((dependence: any) => {
                            return {
                                id: dependence.Trigger.ID,
                                name: dependence.Trigger.Title,
                            };
                        });
                    tempFieldsForm[i]["options"] = _.uniqWith(options, _.isEqual).length > 0 && _.uniqWith(options, _.isEqual) || [{
                        id: 0,
                        name: "Нет вариантов",
                        available: false
                    }];
                }
            }
        }
        if (inc && default5WayCardDataInc) {
            for (let i = 0; i < tempFieldsForm.length; i++) {
                if (tempFieldsForm[i]["key"] === "Location" || tempFieldsForm[i]["key"] === "Department" || tempFieldsForm[i]["key"] === "Region" || tempFieldsForm[i]["key"] === "Trigger") {
                    tempFieldsForm[i]["disabled"] = true
                }
            }
        }
        setFields([...tempFieldsForm]);
    }, [dependencies, dependenciesDeviationReport, type, inc, default5WayCardDataInc]);

    useEffect(() => {
        if (closeAllModals) {
            localStorage.setItem('NEW_INC', '');
            localStorage.setItem('default5WayCardDataInc', '');
            setOpen(false);
            setCancel(false);
            setAdd5Way(false);
        }
    }, [closeAllModals]);

    useEffect(() => {
        if (statusAdd5Way === "SUCCESS") {
            setOpen(false);
            setCancel(false);
            setFormData(null);
        }
    }, [statusAdd5Way]);

    useEffect(() => {
    if (type === FiveWhyType) {
      const tempFieldsForm = [...fields];
      if (problemRepeatCounShow) {
        for (let i = 0; i < tempFieldsForm.length; i++) {
          if (tempFieldsForm[i]["key"] === "ProblemsCount") {
            tempFieldsForm[i]["hide"] = false;
            tempFieldsForm[i]["width"] = "w-full"
          }
          if (tempFieldsForm[i]["key"] === "ProblemRepeat") {
            tempFieldsForm[i]["width"] = "w-full"
          }
        }
      } else {
        for (let i = 0; i < tempFieldsForm.length; i++) {
          if (tempFieldsForm[i]["key"] === "ProblemsCount") {
            tempFieldsForm[i]["hide"] = true;
            tempFieldsForm[i]["width"] = "w-full"
          }
          if (tempFieldsForm[i]["key"] === "ProblemRepeat") {
            tempFieldsForm[i]["width"] = "w-full"
          }
        }
      }
      setFields([...tempFieldsForm]);
    }
  }, [problemRepeatCounShow]);


    useEffect(() => {
        if (formData && Object.keys(formData).length > 0) {
            setCustomLoading(true);
            const sendData: any = {
                Title: (type === FiveWhyType && "5Почему") || "Отчет об отклонении",
                Location: formData.Location.id,
                Department: formData.Department.id,
                Region: formData.Region.id,
                Trigger: formData.Trigger.id,
                KPI: formData.KPI.id,
                Description: (type === FiveWhyType && "5Почему") || "Отчет об отклонении",
                Actions: formData.Actions.trim() + " ",
                Type5Way: type,
                Date5Way: (typeof formData.Date5Way.startDate === "string" && new Date(formData.Date5Way.startDate)) || formData.Date5Way.startDate,
                Editors: formData.Editors,
                Details: formData.Details.trim() + " ",
                ProblemRepeat: formData.ProblemRepeat.id,
                AuthorEmail: currentUser.email,
                ProblemsCount: formData.ProblemsCount,
                DetailsInTree: problemInTree,
                Hide: 0,
                ID: create5WayID
            }
            if (inc) {
                sendData['Incident'] = inc;
            }
            console.log('FORM_DATA_5WAY_ADD: ', sendData);
            updateItemRequest({ listName: myTasks5WayListName, body: sendData }).then(ID5Way => {
                if (emailsSender) {
                    if (type === FiveWhyType) {
                        if (currentUser.email !== formData.Editors.split(";")[formData.Editors.split(";").length - 1]) {
                            const timestamp = moment().unix();
                            const emailBody = {
                                Body: `Здравствуйте ${users[formData.Editors.split(";")[formData.Editors.split(";").length - 1]] && users[formData.Editors.split(";")[formData.Editors.split(";").length - 1]]["displayName"]},<br/><br/>Сотрудник ${currentUser.displayName} назначил Вас ответственным за следующий этап эстафеты 5Почему<br/><br/><a href="${siteUrl}/App/${mode}.aspx/dashboard/3?5WayCardMobile=${ID5Way}">${formData.Description.trim()}</a>`,
                                DateToBeSentAt: moment().subtract(12, 'hours').toDate(),
                                Title: 'Мои Задачи | Назначение ответственного за эстафету 5Почему',
                                Subject: 'Мои Задачи | Назначение ответственного за эстафету 5Почему',
                                Recepients: formData.Editors.split(";")[formData.Editors.split(";").length - 1],
                                CheckDoc: String(timestamp)
                            };
                            Promise.all([sendEmail(emailBody)]).then(() => {
                                setProblemInTree("");
                                setID5WayAdd(ID5Way);
                                setAdd5Way(true);
                                setCustomLoading(false);
                            });
                        } else {
                            setProblemInTree("");
                            setID5WayAdd(ID5Way);
                            setAdd5Way(true);
                            setCustomLoading(false);
                        }
                    } else {
                        const peopleEmail = formData.Editors.split(";").filter((email: string) => email !== currentUser.email);
                        const timestamp = moment().unix();
                        let emailsBody: any = [];
                        peopleEmail.forEach((email: string) => {
                            emailsBody = [...emailsBody, sendEmail({
                                Body: `Здравствуйте ${users[email] && users[email]["displayName"]},<br/><br/>Сотрудник ${currentUser.displayName} назначил Вас участником в Отчете об отклонении<br/><br/><a href="${siteUrl}/App/${mode}.aspx/dashboard/3?deviationCardMobile=${ID5Way}">${formData.Description.trim()}</a>`,
                                DateToBeSentAt: moment().subtract(12, 'hours').toDate(),
                                Title: 'Мои Задачи | Назначение участника Отчета об отклонении',
                                Subject: 'Мои Задачи | Назначение участника Отчета об отклонении',
                                Recepients: email,
                                CheckDoc: String(timestamp)
                            })]
                        });
                        if (emailsBody.length > 0) {
                            Promise.all(emailsBody).then(() => {
                                setProblemInTree("");
                                setID5WayAdd(ID5Way);
                                setAdd5Way(true);
                                setCustomLoading(false);
                            });
                        } else {
                            setProblemInTree("");
                            setID5WayAdd(ID5Way);
                            setAdd5Way(true);
                            setCustomLoading(false);
                        }
                    }
                } else {
                    setProblemInTree("");
                    setID5WayAdd(ID5Way);
                    setAdd5Way(true);
                    setCustomLoading(false);
                }
            });
        }
    }, [formData]);

    useEffect(() => {
        if (!add5Way && ID5WayAdd) {
            localStorage.setItem('NEW_5WAY', ID5WayAdd.toString());
            setID5WayAdd(null);
            if (type === FiveWhyType) {
                const newSearchParams = new URLSearchParams(query);
                newSearchParams.delete("5WayCardMobile");
                newSearchParams.set("5WayCardMobile", ID5WayAdd.toString());
                setQuery(newSearchParams);
            } else {
                const newSearchParams = new URLSearchParams(query);
                newSearchParams.delete("deviationCardMobile");
                newSearchParams.set("deviationCardMobile", ID5WayAdd.toString());
                setQuery(newSearchParams);
            }
        }
    }, [add5Way, ID5WayAdd, query, setQuery, type]);

    useEffect(() => {
        if (type === FiveWhyType && Object.keys(dependenceTrigger).length > 0) {
            setKPI({
                id: dependenceTrigger['Kpi'].ID,
                name: dependenceTrigger['Kpi'].Title
            });
        } else if (Object.keys(dependenceDeviationReportTrigger).length > 0) {
            setKPI({
                id: dependenceDeviationReportTrigger['Kpi'].ID,
                name: dependenceDeviationReportTrigger['Kpi'].Title
            });
        }
    }, [dependenceTrigger, dependenceDeviationReportTrigger, type]);

      useEffect(() => {
        if (open) {
          const sendData = {
            Title: `Временный почему`,
            Type5Way: type,
          };
          addItemRequest({ listName: myTasks5WayListName, body: sendData }).then(
            (FiveWayID) => {
              console.log('Создали почему #: ', FiveWayID);
              setCreate5WayID(FiveWayID);
            });
        }
      }, [open]);

      useEffect(() => {
        if (cancel) {
          setRemove5Way(true)
        }
        if (!cancel && remove5Way) {
          deleteItemRequest({ listName: myTasks5WayListName, ID: create5WayID }).then(() => {
            console.log('Удалили почему #: ', create5WayID);
            setCreate5WayID(0);
            setRemove5Way(false);
          });
        }
      }, [cancel]);


    return (
        <>
            {fromTaskCard ? (
                <button type="button" className={`${taskCardButtonClassName} `} onClick={() => setOpen(true)}>
                    5Почему
                </button>
                ) : (
                <>
                {type === FiveWhyType &&
                <Button open={open} setOpen={setOpen} typeIcon="add" classBg="btn-dark" text="Создать 5Почему" icon={true} />
                ||
                <Button open={open} setOpen={setOpen} typeIcon="add" classBg="btn-dark" text="Создать Отчет об отклонениях" icon={true} />
                }</>
                )}

            <DrawerComponent setOpenCustomModal={setCancel} zIndex={zIndex} open={open} toggleDrawer={setOpen}>
                <div className="flex flex-col p-6 shrink">
                    {type === FiveWhyType &&
                        <h1 className="mb-8 text-black">Создание 5 Почему</h1>
                        ||
                        <h1 className="mb-8 text-black">Создание Отчета об отклонении</h1>
                    }
                    {(statusAdd5Way === "LOADING" || customLoading) && (
                        <div className="flex items-center justify-center w-full mt-5 mb-5">
                            <Loading />
                        </div>
                    ) || (
                            <Form
                                type="add_my_tasks_5way"
                                setFormData={setFormData}
                                fieldsForm={fields.filter((field: any) => field.key !== 'Description')}
                                type5way={type}
                                setOpenCancelAddCard={setCancel}
                                openCancelAddCard={cancel}
                                defaultValues={defaultValues}
                                setDependenceFields={setDependenceFields}
                                setDependenceFields5Way={setDependenceFields5Way}
                                kpi={kpi}
                                ID5WayAdd={create5WayID}
                                zIndex={zIndex}
                                card5WayTree={card5WayTree}
                                setCard5WayTree={setCard5WayTree}
                                openTree={openTree}
                                setOpenTree={setOpenTree}
                                setProblemInTree={setProblemInTree}
                                problemInTree={problemInTree}
                                setProblevRepeatCounShow={setProblevRepeatCounShow}
                                isMobile5WayCard
                            />
                        )}
                </div>
            </DrawerComponent>
            <Modal
                zIndex={zIndex ? zIndex + 10 : 70}
                modalClassName="min-h-px"
                open={cancel}
                toggleDialog={setCancel}
                autoClose={autoCloseModal}
                onAutoClose={() => {
                    setCloseAllModals(!closeAllModals);
                }}
            >
                <header className="px-10 pb-4">
                    <h2>Вы действительно хотите отменить изменения?</h2>
                </header>

                <div className="px-10 py-5">
                    <p>
                        При нажатии на “Отмена” возврат действий будет невозможен
                    </p>
                </div>

                <footer className="flex flex-col gap-2 w-full px-10 pt-10 mt-4 border-t">
                    <TGButton color="white" onClick={(e) => setCancel(false)}>
                        Закрыть
                    </TGButton>
                    <TGButton color="bluedark" onClick={(e) => setCloseAllModals(!closeAllModals)}>
                        Подтвердить отмену
                    </TGButton>
                </footer>
            </Modal>
            <Modal zIndex={zIndex ? zIndex + 10 : 70} modalClassName="min-h-px" open={add5Way} toggleDialog={setAdd5Way}>
                <header className="px-10 pb-4">
                    <h2>Вы успешно сохранили форму</h2>
                </header>

                <div className="px-10 py-5">
                    <p>
                        Форма сохранена со всеми изменениями
                    </p>
                </div>

                <footer className="flex justify-center w-full px-10 pt-10 mt-4 border-t">
                    <TGButton color="bluedark" onClick={(e) => setCloseAllModals(!closeAllModals)}>
                        Закрыть
                    </TGButton>
                </footer>
            </Modal>
        </>
    );
};

export default Add5Way;
